import initializeValues from './initializeValues';
import openModal from './openModal';
export default (values, callback) => (dispatch) => {
    const newValues = {
        callback,
        id: values.id,
        snow_load: values.snow_load,
        wind_speed: values.wind_speed,
    };
    dispatch(initializeValues(newValues));
    dispatch(openModal(true));
};
